import script from "./EditUserModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditUserModal.vue?vue&type=script&setup=true&lang=ts"

import "./EditUserModal.vue?vue&type=style&index=0&id=7855c0dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7855c0dd"]])

export default __exports__